// src/components/fix-actions/redesign/action-items-flag.ts
//
// Feature flag for the Action Items (Fix Actions) redesign.
//
// The redesign is a front-end swap against the UNCHANGED backend: the
// orchestration in fix-actions-page.tsx stays intact and only the
// presentational children are swapped when this flag is on. Legacy remains
// the default.
//
// Three ways to enable, checked in this order (first wins):
//   1. URL param  ->  add ?actionItemsUI=1 to the URL   (instant, no restart)
//   2. localStorage key "actionItemsUI" = "1"           (sticky across reloads)
//   3. .env.local ->  VITE_ACTION_ITEMS_UI=1 (or =true) (needs a vite restart)
//
// The URL param also persists itself into localStorage, so once you've opened
// the app with ?actionItemsUI=1 it stays on until you turn it off with
// ?actionItemsUI=0.

function truthy(v: string | null | undefined): boolean {
  const s = String(v ?? "").trim().toLowerCase();
  return s === "1" || s === "true";
}
function falsy(v: string | null | undefined): boolean {
  const s = String(v ?? "").trim().toLowerCase();
  return s === "0" || s === "false";
}

const LS_KEY = "actionItemsUI";

function readFlag(): boolean {
  try {
    if (typeof window !== "undefined") {
      // 1. URL param (also persisted so it survives client-side navigation)
      const q = new URLSearchParams(window.location.search).get("actionItemsUI");
      if (q !== null) {
        try {
          if (truthy(q)) window.localStorage.setItem(LS_KEY, "1");
          else if (falsy(q)) window.localStorage.removeItem(LS_KEY);
        } catch {
          /* localStorage may be unavailable */
        }
        if (truthy(q)) return true;
        if (falsy(q)) return false;
      }
      // 2. localStorage
      try {
        if (truthy(window.localStorage.getItem(LS_KEY))) return true;
      } catch {
        /* ignore */
      }
    }
    // 3. build-time env
    const env = (import.meta as any)?.env ?? {};
    return truthy(env.VITE_ACTION_ITEMS_UI);
  } catch {
    return false;
  }
}

export const ACTION_ITEMS_UI: boolean = readFlag();
